/* eslint-disable array-callback-return */
import { SnackbarKey, useSnackbar } from 'notistack';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Snackbar } from 'src/components/snackbar';

export const useCloseSnackBar = () => {
  const location = useLocation();
  const { closeSnackbar } = useSnackbar();
  let errorSnackBarVal = Snackbar.getErrorSnackbarId();

  React.useEffect(() => {
    const removeErrorSnackBarKey = (val: SnackbarKey) => {
      const index = errorSnackBarVal.indexOf(val);
      if (index !== -1) {
        errorSnackBarVal.splice(index, 1);
      }
    };
    errorSnackBarVal.map((item) => {
      closeSnackbar(item);
      removeErrorSnackBarKey(item);
    });
  }, [location.pathname, closeSnackbar, errorSnackBarVal]);
};
